import React, { FC } from "react";
import { Route, Switch } from "react-router-dom";

import NotFound from "@/scenes/404";
import ShopSubscriptionExpired from "@/scenes/subscription/Expired";
import ShopSubscriptionOrderList from "@/scenes/subscription/OrderList";
import Renewal from "@/scenes/subscription/Renewal";
import RenewalConfirmPageWithShopInfo from "@/scenes/subscription/RenewalConfirmPageWithShopInfo";
import RenewalConfirm from "@/scenes/subscription/RenewalConfirm";

interface SubscriptionRoutesProps {}

/**
 * 顶层范围的 订购/升级相关 路由
 */
const SubscriptionRoutes: FC<SubscriptionRoutesProps> = React.memo(function (props) {
    return (
        <Switch>
            {/* 发货易订购过期页面 */}
            <Route
                exact
                path={[
                    "/ecMarketShopSubscription/:shopId", // TODO: 废弃，后续删除此链接
                    "/subscription/expired/:shopId",
                ]}
                component={ShopSubscriptionExpired}
            />

            {/* 发货易订购过期时，给用户查看自己的订购列表 */}
            <Route
                exact
                path={[
                    "/ecMarketShopSubscription/order/:shopId", // TODO: 废弃，后续删除此链接
                    "/subscription/order/list/:shopId",
                ]}
                component={ShopSubscriptionOrderList}
            />

            {/* 续费 */}
            <Route
                exact
                path={[
                    "/renewal", // TODO: 废弃，后续删除此链接
                    "/subscription/renewal",
                ]}
                component={Renewal}
            />

            {/* 续费订购确认提示 */}
            <Route
                exact
                path={[
                    "/renewConfirm", // TODO: 废弃，后续删除此链接
                    "/subscription/renewal/confirm",
                ]}
                component={RenewalConfirmPageWithShopInfo}
            />

            {/* 新续费订购确认提示 */}
            <Route exact path="/subscription/renewal/confirm-v2" component={RenewalConfirm} />

            <Route component={NotFound} path="*" />
        </Switch>
    );
});

export default SubscriptionRoutes;
